import { useState, useEffect } from 'react';
import { Button } from 'antd';
import { Link } from 'react-router-dom';
import './CookieConsent.css';

const COOKIE_CONSENT_KEY = 'ark_portal_cookie_consent';

/**
 * Cookie Consent Banner
 * Shows a banner at the bottom of the page for cookie consent
 * Complies with data protection regulations
 */
export const CookieConsent: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Check if user has already given consent
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      // Show banner after a short delay
      setTimeout(() => setVisible(true), 1000);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted');
    setVisible(false);
    // Google Analytics is defined in index.html and only loads once consent is given
    (window as Window & { rkLoadAnalytics?: () => void }).rkLoadAnalytics?.();
  };

  const handleDecline = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-consent-banner">
      <div className="cookie-consent-content">
        <div className="cookie-consent-text">
          <p>
            <strong>🍪 We use cookies</strong>
          </p>
          <p>
            We use essential cookies to ensure the platform works properly and to remember your preferences.
            With your permission we also use Google Analytics to understand how the site is used.
            By clicking "Accept", you agree to our use of cookies.
            Learn more in our <Link to="/privacy-policy">Privacy Policy</Link>.
          </p>
        </div>
        <div className="cookie-consent-actions">
          <Button onClick={handleDecline} size="large">
            Decline
          </Button>
          <Button type="primary" onClick={handleAccept} size="large">
            Accept Cookies
          </Button>
        </div>
      </div>
    </div>
  );
};
